<template>
  <div class="w-full sm:w-full md:w-2/3 lg:w-2/3 xl:w-2/3 mb-4">
    <vs-card id="ehs_table" class="vs-con-loading__container px-2 widget-card">
      <card-header :title="$t('widget_ehs_by_status')"></card-header>

      <vs-row vs-type="flex" vs-justify="flex-end">
        <vs-col vs-w="12" vs-sm="12" vs-type="flex" vs-justify="flex-end">
          <div
            v-for="(label, i) in labels"
            :key="i"
            @click="RenderTable(label.name)"
          >
            <vs-chip class="label-status" :color="label.color">{{
              label.name
            }}</vs-chip>
          </div>
        </vs-col>
      </vs-row>
      <vs-row >
        <vs-col  class="widget-table">
            <table-striped
              :users="permitListTable"
            ></table-striped>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import TableStriped from '@/views/pages/home/tables/TableStriped.vue'
//requests
import dashboard from '@/http/requests/ehs'

import loading from '@/mixins/Loading.js'
import CardHeader from './CardHeader.vue'

export default {
  mixins: [loading],
  components: {
    TableStriped,
    CardHeader,
  },
  computed: {
    isLoading() {
      return this.loading.ehs_table
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('ehs_table')
      } else {
        this.closeLoading('ehs_table')
      }
    },
  },
  data() {
    return {
      labels: [],
      permitList: [],
      permitListTable: [],
      loading: {
        ehs_table: false,
      },
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading.ehs_table = true
      dashboard
        .ehsTableList()
        .then((res) => {
          this.permitList = res.data.permissions
          this.findLabels(this.permitList)
          this.permitListTable = this.filterByState(
            this.permitList,
            'Not in Compliance'
          )
          if (this.permitListTable.length == 0) {
            this.permitListTable = this.filterByState(
              this.permitList,
              'In Compliance'
            )
          }
          this.loading.ehs_table = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.ehs_table = false
        })
    },
    filterByState(data, state) {
      const filteredData = []
      data.forEach((element) => {
        if (element.status_name == state) {
          filteredData[filteredData.length] = element
        }
      })
      return filteredData
    },
    RenderTable(Status) {
      this.permitListTable = this.filterByState(this.permitList, Status)
    },
    findLabels(data) {
      const labels = []
      data.forEach((element) => {
        if (labels.indexOf(element.status_name) === -1) {
          labels[labels.length] = element.status_name
          this.labels[this.labels.length] = {
            name: element.status_name,
            color:
              element.status_color == null ? '#E8ECE9' : element.status_color,
          }
        }
      })
    },
  },
}
</script>

<style>
.label-status {
  margin: 1rem;
}

.label-status:hover {
  cursor: pointer;
}
</style>